document.addEventListener('DOMContentLoaded', function () {
  // Récupérer l'URL actuelle
  const currentUrl = window.location.href;

  console.log("URL actuelle :", currentUrl);

  // Récupérer les blocs des deux formulaires
  const frenchForm = document.getElementById('shopify-block-ANm03Y2NhYWJKM3Q1Q__hulk_form_builder_form_block_XLzV6c');
  const englishForm = document.getElementById('shopify-block-ASkIrNGFQejlRWGtpT__hulk_form_builder_form_block_qnQaam');

  // Vérifier que les deux blocs existent
  if (!frenchForm || !englishForm) {
    console.warn("Un ou plusieurs blocs de formulaire sont introuvables !");
    return;
  }

  // Masquer les deux blocs par défaut
  frenchForm.style.display = 'none';
  englishForm.style.display = 'none';

  // Détecter la langue via l'URL
  if (currentUrl.includes('/en/')) {
    // Afficher le formulaire anglais
    englishForm.style.display = 'block';
  } else {
    // Afficher le formulaire français par défaut
    frenchForm.style.display = 'block';
  }
});

